const user =
{
    snacks :
    {
        add    : 'Une ressource est ajoutée dans vos favoris',
        remove : 'Une ressource est supprimée des favoris',
    },
};

export default user ;